export default
    {
        path: "/standard",
        component: () => import('../view/standard/main.vue'),
        props: (route) => (
            {
                token:route.query.token,
                koaToken:route.query.koaToken,
                userId:route.query.userId,
                deviceType:route.query.deviceType,
                deviceName:route.query.deviceName,
                st:route.query.st,
                newVersion:route.query.newVersion,
                secondLoginType:route.query.secondLoginType,
                secondAssessToken:route.query.secondAssessToken,
                deviceId:route.query.deviceId,
            }
        ),
        children: [
            {
                path: "index",
                component: () => import('../view/standard/index.vue'),
                props: (route) => (
                    {
                        token:route.query.token,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType,
                        deviceName:route.query.deviceName,
                        st:route.query.st,
                        newVersion:route.query.newVersion,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                    }
                ),
            },
            {
                path: 'standardTextInput',
                name: 'standardTextInput',
                component: () => import('../view/standard/standardInput.vue'),
                
            },
            {
                path: 'standarToast',
                name: 'standarToast',
                component: () => import('../view/standard/standarToast.vue'),
                
            }  ,
            {
                path: 'standarConfirm',
                name: 'standarConfirm',
                component: () => import('../view/standard/standarConfirm.vue'),
                
            } ,
            {
                path: 'standarDrawer',
                name: 'standarDrawer',
                component: () => import('../view/standard/standarDrawer.vue'),
                
            } ,
            {
                path: 'standarDate',
                name: 'standarDate',
                component: () => import('../view/standard/standarDate.vue'),
            } ,
            {
                path: 'standarAddress',
                name: 'standarAddress',
                component: () => import('../view/standard/standarAddress.vue'),
            },
            {
                path: 'standarFile',
                name: 'standarFile',
                component: () => import('../view/standard/standarFile.vue'),
            },
            {
                path: 'standardRadio',
                name: 'standardRadio',
                component: () => import('../view/standard/standardRadio.vue'),
            },
            {
                path: 'standarMultiselect',
                name: 'standarMultiselect',
                component: () => import('../view/standard/standarMultiselect.vue'),
            },
            {
                path: 'standardSingleNative',
                name: 'standardSingleNative',
                component: () => import('../view/standard/standardSingleNative.vue'),
            },
            {
                path: 'standardTips',
                name: 'standardTips',
                component: () => import('../view/standard/standardTips.vue'),
            },
            {
                path: 'standardCopy',
                name: 'standardCopy',
                component: () => import('../view/standard/standardCopyInput.vue'),
            },
            {
                path: 'standardListView',
                name: 'standardListView',
                component: () => import('../view/standard/standardListView.vue'),
            },
            {
                path: 'standardListViewAnther',
                name: 'standardListViewAnther',
                component: () => import('../view/standard/standardListViewAnther.vue'),
            },
            {
                path: 'standardCell',
                name: 'standardCell',
                component: () => import('../view/standard/standarCell.vue'),
            },
            {
                path: 'standardApplicant',
                name: 'standardApplicant',
                component: () => import('../view/standard/standardApplicant.vue'),
            },
            {
                path: 'standardDictionary',
                name: 'standardDictionary',
                component: () => import('../view/standard/standardDictionary.vue'),
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/standardRouter.js